import DrfRestBase from './drf_rest_base';

export default class ApiSubscriptionTemplate extends DrfRestBase{
    static endpoint='/shop/api/subscription-template/';
}
